var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"number"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.number),expression:"number"}]},[_vm._v(" "+_vm._s(_vm.number)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }